const React = require('react');
const Swipe = require('../../Swipe');
const Person = require('../../Person');

const isNode = (typeof process !== 'undefined');
const Map = isNode ? require('../../Map') : () => <div/>;

class PropertyShow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: 0
        };

        this.slideNext = this.slideNext.bind(this);
        this.slidePrev = this.slidePrev.bind(this);
    }

    componentDidMount() {
        this.refs.swipe.swiper.on('slideChangeEnd', () => {
            this.setState({selected: this.refs.swipe.swiper.activeIndex});
        });
    }

    componentWillUnmount() {
        this.refs.swipe.swiper.off('slideChangeEnd');
    }

    slideNext() {
        this.refs.swipe.swiper.slideNext();
    }

    slidePrev() {
        this.refs.swipe.swiper.slidePrev();
    }

    render() {
        const props = this.props;
        const {selected} = this.state;
        const showMap = props.showMapOptions && props.showMapOptions._selected === 'showMap';
        const mapPosition = showMap ? props.showMapOptions.showMap : null;


        const arrowIcon = <svg x="0px" y="0px" viewBox="0 0 46.4 45.5">
            <path fill="#535868" d="M13,2.5c-1.1,1.1-1.1,3,0,4.1l16.3,16.2l-16,16c-1.2,1.1-1.2,2.9-0.1,4.1s2.9,1.2,4.1,0.1 c0,0,0.1-0.1,0.1-0.1l18-18c1.1-1.1,1.1-3,0-4.1L17.1,2.5C16,1.4,14.1,1.4,13,2.5z"/>
        </svg>;

        return (
        <section className="property">
            <div className="property__container">
                {/*TODO: Component'ize this*/}

                {/* Title and statusbar */}
                <div className="property__title-bar">
                    {props.displayName} &ndash; {props.city}
                </div>

                {/* Slideshow */}
                {props.images.length > 0 && (
                <div className="property__slideshow-container">
                    <Swipe ref="swipe" options={{loop: false, centeredSlides: true, slidesPerView: 'auto' }} pagination={false}>
                        {props.images.map(image => {
                            return (
                            <div className="property__slide" onClick={this.slideNext}>
                                <img src={image} draggable={false}/>
                            </div>
                            )
                        })}
                    </Swipe>
                    <div className="property__slideshow-controls">
                        <a className="property__slideshow-control-btn property__prev-btn" onClick={this.slidePrev}>
                            {arrowIcon}
                        </a>
                        <span className="property__slideshow-progress">
                        {selected + 1}/{props.images.length}
                    </span>
                        <a className="property__slideshow-control-btn property__next-btn" onClick={this.slideNext}>
                            {arrowIcon}
                        </a>
                    </div>
                </div>
                )}

                {/* Content */}

                <div className="property__columns">
                    <div className="property__left-column">
                        <div className="property__excerpt" dangerouslySetInnerHTML={{__html: props.excerpt}} />
                        <div className="property__body" dangerouslySetInnerHTML={{__html: props.body}} />
                    </div>
                    <div className="property__right-column">
                        {props.contactPerson && (
                            <Person person={props.contactPerson} />
                        )}

                        {showMap && <Map position={mapPosition} address={props.address} city={props.city} />}
                    </div>
                </div>
            </div>
        </section>
        )
    }
}

module.exports = PropertyShow;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/property-show/Component/index.jsx